import { NestedRoute } from '../../domain/Types';
import Folder from '../../pages/Folder';
import Assistant from '../../pages/Assistant';
import { chatbubbleEllipses, cube, folderOpenSharp, folderSharp, share } from 'ionicons/icons';
import Initiative from '../../pages/Initiative';

const generateClientRoutes = (data : any) => {

    if (!data) data = [];

    const folderRoutes = data.map((folder: { slug: string; name: string; assistants: any[] }) => {
      const folderRoute: NestedRoute = {
        path: `/${folder.slug}`,
        component: Folder,
        exact: true,
        label: folder.name,
        icon: folderSharp, 
        iconOpen: folderOpenSharp, 
        menu: true,
        children: folder.assistants.map((assistant: { slug: string; name: string }) => ({
          path: `/${assistant.slug}`,
          component: Assistant,
          exact: true,
          label: assistant.name,
          icon: chatbubbleEllipses, 
          menu: true
        }))
      };
      return folderRoute;
    });

    const initiativeRoutes: NestedRoute[] = [
      { 
        path: '',
        component: Initiative, 
        exact: true, 
        menu: true,
        icon: cube, 
        label: 'Client overview'
      }
    ]    

    return [...initiativeRoutes, ...folderRoutes];
  };


export default generateClientRoutes;

